import React from "react";
import styled, { css } from "styled-components";
import MuiTypography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const SectionHeader = ({
  children,
  endAdornment,
  hasStartAdornment = true,
  marginBottom = true,
  isBold = true,
  useBackground = true,
  paddingBottom = true,
  fontSize = "normal",
}) => {
  const classes = useStyles({ useBackground, fontSize });

  return (
    <Container
      marginBottom={marginBottom}
      useBackground={useBackground}
      isFlex={hasStartAdornment || endAdornment}
      paddingBottom={paddingBottom}
      fontSize={fontSize}
    >
      <MuiTypography className={classes.root}>{children}</MuiTypography>
      {endAdornment && <AdornmentWrapper>{endAdornment}</AdornmentWrapper>}
    </Container>
  );
};

export default SectionHeader;

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    fontSize:
      props.fontSize === "large" ? "1.2rem !important" : "1rem !important",
    color: "var(--text-primary)",
    fontWeight: props.isBold ? 700 : 400,
  }),
}));

const Container = styled.div`
  display: ${({ isFlex }) => (isFlex ? "flex" : "inherit")};
  align-items: center;

  ${({ useBackground, marginBottom }) =>
    useBackground
      ? css`
          background-color: var(--surface-50);
          padding-inline: 0.5em;
          border-radius: 4px;
          ${marginBottom ? "margin-bottom: 1em;" : "margin-block: 0.5em;"}
        `
      : css`
          background-color: transparent;
          margin: 0;
          padding: 0;
          height: auto;
        `}

  ${({ useBackground, paddingBottom }) =>
    useBackground ? `padding-bottom: ${paddingBottom ? "0.5em" : "0"};` : ""}

  ${({ fontSize }) => (fontSize === "large" ? "padding-block: 0.8rem" : "")}
`;

const AdornmentWrapper = styled.div`
  margin-left: 0.5em;
  display: flex;
  align-items: center;
`;
